module.exports = {
  global: {
    close: 'close',
    resins: 'Resins',
    additives: 'Additives',
    all: 'All',
    login: 'login',
    logout: 'logout',
    userName: 'User Name',
    userAccountName: 'Display Name',
    countryName: 'Country/Region',
    phone: 'Company Phone/Cell',
    businessModel: 'Business Model',
    passWord: 'Password',
    currentPass: 'Current PassWord',
    newPassWord: 'New Password',
    repeatPass: 'Repeat Password',
    email: 'Email Address',
    companyName: 'Company Name',
    position: 'Function',
    register: 'Register',
    registration: 'registration',
    cancel: 'cancel',
    submit: 'submit',
    goBack: 'Back',
    followWechat: 'Follow the public account',
    thanksRegister: 'Thank you for registering this site',
    registerSuccess: 'You have successfully registered, please wait for the administrator to confirm activation of your account, your registered mailbox will receive an email notification of successful registration.',
    backToHome: 'Back to Home',
    backToLastPage: 'Back to Last Page',
    loginSuccess: 'You have logged in successfully, now you can access all the functions of BASF Product Center.',
    readMore: 'Read More',
    confirm: 'Confirm',
    cookieDescription: 'This application uses cookies to meet your needs and functions. By using this application, you agree to our ',
    cookiePolicy: 'Privacy Policy',
    noMoreProduct: 'No More Products',
    noMoreFormulation: 'No More Formulations',
    noMoreFiles: 'No More Download Files',
    required: '*',
    min: 'At least 8 characters',
    max: 'Cannot exceed 40 characters',
    emailMatch: 'Please enter a valid email address',
    confirmPass: 'Confirm the password is incorrect',
    chineseVarchar: 'Username can only contain underscores or numbers in English characters',
    phoneNumber: 'You entered an illegal mobile phone number',
    FullwidthChar: 'You entered an illegal full-width character',
    invilideChar: 'You entered an illegal character',
    forgetPass: 'Please input your email address to reset password.',
    resetPass: 'Input your new pass',
    myFavorite: 'My Collection',
    orderHistory: 'Order History',
    orderNumber: 'Order Number',
    orderTotalPrice: 'Total Price',
    orderProduct: 'Product',
    orderStatus: 'Order Status',
    orderCreate: 'Creation time',
    OrderTime: 'Order time',
    accountSetting: 'Account Settings',
    welcome: 'Welcome',
    forget: 'Forgot your password?',
    agree: 'Agree',
    private: 'Privacy Agreement',
    privateContent1: '1. I agree to provide the above information to BASF (China) Co., Ltd. (“BCH”) and its Affiliates* inside and/or outside of the People’s Republic of China (collectively referred to as “BASF”) and their respective service providers. ',
    privateContent2: '*Affiliates mean any company or other entity directly or indirectly controlling or controlled by or under direct or indirect common control with BCH. For the purpose of this definition, “control” means direct or indirect ownership of more than fifty percent (50%) of the shares or registered capital (or other equity interests of similar nature) of the said company or entity. ',
    shareThisPage: 'Share This Page',
    copyLink: 'Copy Link',
    sendEmail: 'Send Email',
    myFavoriteProduct: 'Favorite Products',
    myFavoriteFormulation: 'Favorite Formulations',
    loading: 'Loading...',
    version: 'Version',
    pleaseSelect: 'Please Select'
  },
  businessModelList: {
    Manufacturing: 'Manufacturing',
    Trade: 'Trade',
    ResearchInstitutes: 'ResearchInstitutes',
  },
  companyPositionList: {
    Marketing: 'Sales/Marketing',
    Technology: 'Technology/R&D',
    Production: 'Production/Quality',
    Procurement: 'Procurement',
    Management: 'Management',
    Others: 'Others',
  },
  companyIndustryList: {
    AutomotiveCoating: 'Automotive Coating',
    IndustrialCoating: 'Industrial Coating',
    WoodCoating: 'Wood Coating',
    PrintingPackaging: 'Printing & Packaging',
    Construction: 'Construction',
    Adhesive: 'Adhesive',
  },
  basket: {
    title: 'Sample Shopping Cart',
    clearBasket: 'Empty shopping cart',
    seeOrder: 'View Shopping Cart',
    productWeight: 'Product Weight'
  },
  productView: {
    basicInfo: 'Basic Information',
    property: 'Technical Parameters',
    formulation: 'formulation',
    download: 'Download',
    share: 'share',
    favorite: 'Add to favorite',
    basket: 'Add to shopping cart',
    techData: 'Technical data',
    techDataDescription: 'For more information, please refer to the product technical specification',
  },
  formulationView: {
    basicInfo: 'Basic Information',
    property: 'property',
    otherInformation: 'Other Information',
    formula: 'formula',
    share: 'share',
    favorite: 'favorite',
    formulationRecipe: {
      formulaRatio: 'Formula ratio',
      formulaWork: 'Explanation',
      formula_Composition: 'Formula composition',
      formula_title: 'Formula calculation',
    },
    Properties: {
      title: 'Technical data of formula'
    }
  },
  industry: {
    noDescription: 'No industry introduction',
    checkFormulation: 'Formulations',
    checkProduct: 'Products',
    products_recommended: 'Product Recommendation'
  },
  onlineRequestForm: {
    title: 'Contact Us',
    description: 'If you have any suggestions or questions regarding the usage of BASF Product Center, please do not hesitate to give us your feedback.',
    feedbackContent: 'Content',
    yourEmail: 'E-mail',
    yourPhone: 'Phone',
    thanks: 'Thanks for your feedback！',
    privateContent1: '2. I agree to receive, through my above email address and mobile phone number, the emails, mobile and WeChat messages etc. that include marketing and promotion information in relation to BASF products*.',
    privateContent2: '*You can unsubscribe such information by sending an email to <a href="mailto:Resins-Additives-Asia@basf.com">Resins-Additives-Asia@basf.com</a>. Alternatively, you can also unsubscribe such information in accordance with the method described in the emails, mobile and WeChat messages etc. that we send to you.',
  },
  loginDialog: {
    title: 'Register and take full advantage of BASF Product Assistant.',
    description: 'Full access to proprietary formulations and complete product data. Personalize your own account and store your favorite or recently visited products and recipes. You can even link your account to colleagues to share your sample order information-these are just some of the advantages of signing up.',
  },
  login: {
    loginTitle: 'Product Center',
    loginTitle2: '',
    welcome: 'Welcome',
    loginSite: '',
  },
  home: {
    search: {
      searchDescription1: 'Welcome to visit BASF Product Center for Resins and Additives! You can easily find product information here. For customers in',
      searchDescription2: ', there are recommended formulations for reference. Online request for samples or purchase at 1688 flagship shop make your orders more convenient than ever. ',
      search: 'Search',
      brand: 'Brand'
    },
    ad: 'Resins & Additives division develops, produces and markets a range of high-quality resins, additives and polymer dispersions worldwide, which are used in formulations for various industries, including coatings, construction, printing and packaging, adhesives and paper. With comprehensive product portfolio and extensive industry knowledge, we offer our customers innovative and sustainable solutions.',
    middleContent: {
      aboutBASF: 'About BASF',
      aboutBASFDescription: 'At BASF, we create chemistry for a sustainable future. We combine economic success with environmental protection and social responsibility. More than 112,000 employees in the BASF Group contribute to the success of our customers in nearly all sectors and almost every country in the world. Our portfolio is organized into six segments: Chemicals, Materials, Industrial Solutions, Surface Technologies, Nutrition & Care and Agricultural Solutions. BASF generated sales of €68.9 billion in 2023. BASF shares are traded on the stock exchange in Frankfurt (BAS) and as American Depositary Receipts (BASFY) in the U.S. Further information at ',
      aboutBASFDescriptionEnd: '.',
      registerTitle: 'Make the most of BASF Product Center',
      registerDescription: 'Get full access to exclusive formulations and complete product data. Individualize your own account and store favorite or order samples online. You can also easily download all product brochures and technical datasheets.',
      registerDescriptionPart: 'Get full access to exclusive formulations and complete product data. Individualize your own account and store favorite or order samples online. You can also easily download all product brochures and technical datasheets.',
      contact: 'Contact Us',
      shanghaiInfo: {
        title: 'ASEAN',
        street: 'Lot 19.02, 1 Powerhouse',
        region: 'Bandar Utama ',
        city: '47800 Petaling Jaya',
        state: 'Selangor, Malaysia',
        phone: 'Tel: +603 7612 1888',
      },
      beijingInfo: {
        title: 'Australia & New Zealand',
        street: 'Level 12, 28 Freshwater Place',
        address: 'Southbank VIC 3006 ',
        detail: 'Australia',
        phone: 'Tel: +61 3 8855 6600',
      },
      guangzhouInfo: {
        title: 'Korea',
        city: '15F KCCI Building ',
        street: '39 Sejong-daero, Jung-gu',
        address: '04513 Seoul, Korea',
        phone: 'Tel: +82 2 3707 7500 ',
      },
      taiwanInfo: {
        title: 'South Asia',
        city: 'Plot No 12, TTC Area,',
        street: 'Thane Belapur Road,',
        address: 'Turbhe Navi',
        postCode: 'Mumbai 400705, India',
        phone: 'Tel: +91 22 6712 7777',
      },
      xianggangInfo: {
        title: 'Japan',
        city: 'OVOL Nihonbashi Bldg.',
        street: '3F 3-4-4 Nihonbashi',
        address: 'Muromachi,Chuo-ku,',
        postCode: 'Tokyo 103-0022, ',
        city2: 'Japan',
        phone: 'Tel: +81 3 5290 3000',
      },
      greaterChinaInfo: {
        title: 'Greater China',
        city: 'East Asia Regional Headquarters',
        street: 'Resins & Additives',
        address: '36F Two Taikoo Place',
        phone: '979 King’s Road, Quarry Bay ',
        title2: 'Hong Kong  ',
        city2: 'Tel: +852 2731 0111 ',
        email: 'Email: Resins-Additives-Asia@basf.com',
      },
      basfInfo: {
        title: 'Shanghai',
        city: '300 Jiang Xin Sha Road',
        street: 'Pudong, Shanghai 200137',
        address: 'China',
        postCode: 'Tel: +86 21 2039 3509',
        email: 'Email: Resins-Additives-Asia@basf.com',
      },

      basfTaiwanInfo: {
        title: 'Taiwan',
        city: '16th Floor',
        street: '87 Sung Chiang Road ',
        address: 'Taipei 10486 ',
        postCode: 'Taiwan ',
        email: 'Email: Resins-Additives-Asia@basf.com',
      },
    },
    footer: {
      link_buy_site: 'BASF 1688 Flagship Shop',
      copyright: 'Copyright © BASF SE 2020',
      disclaimerLink: 'https://www.basf.com/cn/en/legal/disclaimer.html',
      disclaimer: 'Disclaimer',
      weChat: 'Welcome to Lab Assistant',
      weChat2: 'Welcome to visit this website via mobile',
    }
  },
  sampleOrder: {
    title: 'Sample order',
    address: 'Address information',
    check: 'Check',
    confirm: 'Confirm',
    orderList: {
      productList: 'Product List',
      productName: 'Product Name',
      productV: 'Product',
      amount: 'Quantity',
      variation: 'Weight/Unit',
      action: 'Delete',
      cancel: 'Cancel product',
      addCart: 'Add to Order',
      unSuccessProduct: 'Incomplete orders',
      cancelOrder: 'Cancel order',
      completeOrder: 'Check Out',
      price: 'Price',
      productWeight: 'Product Weight',
      emptyCart: 'Your sample order is empty, please add products!'
    },
    orderAddress: {
      displayName: 'Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      country: 'Country',
      state: 'State',
      city: 'City',
      district: 'District',
      postCode: 'Post Code',
      streetAddress: 'Company Address',
      streetAddress2: 'Street address2',
      company: 'Company',
      editOrder: 'Edit Order',
      goOn: 'Continue',
      sampleApplication: 'Sample Application',
      industry: 'Industry'
    },
    OrderResume: {
      title: 'Order Address Information',
      country: 'Country / Region',
      company: 'Company',
      address: 'Address',
      postCode: 'Post Code',
      totalPrice: 'Total Amount',
      orderInfo: 'Order Details',
      amount: 'Quantity',
      price: 'Unit Price',
      editAddress: 'Edit Address',
      completeOrder: 'Complete order'
    },
    orderComplete: {
      congratulations: 'Congratulations on your successful order',
      message: 'Please pay attention to check the emails sent by us, your registered mailbox will receive email notification of order information.',
      goHome: 'Back to Home',
      seeProduct: 'Browse products'
    },
  },
  formulationFilter: {
    select: 'select',
    selectFormulation: 'find formulation',
    moreFormulation: 'find more',
    gloss_60: 'Gloss (60°)',
    sheet_metal: 'Sheet Metal',
    thickness: 'Thickness',
    SST: 'SST',
    filterSubtitle: 'Waterborne resins for metal protective coatings',
    withOutFilterSubtitle: 'Other formulations for industrial coating'
  },
  formulations: {
    other: 'other',
  },
  accountSetting: {
    title: 'Personal Information Modify',
    confirm: 'confirm',
    edit: 'edit',
    successMessage: 'Personal information modified successfully',
  },
  download: {
    product_catalogue: 'Product Catalogue',
    video: 'Video Online',
    training_materials: 'Technology Presentation',
    news: 'Newsroom'
  },
  downloadList: {
    companyNews: 'Cooperate News',
    resins: 'Resins (Coatings)',
    resins2: 'Resins (Printing & Packaging)',
    additives: 'Additives ',
  }
};
